<template>
  <div class="body">
    <!--    <divider/>-->
    <div style="margin-top: 10px;">
      <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">
        基本信息
      </div>
      <table class="gridtable" style="width: 100%" cellpadding="0" cellspacing="0">
        <tbody>
        <tr>
          <td class="tableLabel">编号</td>
          <td class="tdContent">{{ replacementBill.billNo }}</td>
          <td class="tableLabel">客户名称</td>
          <td class="tdContent">{{ replacementBill.customerName }}</td>
          <td class="tableLabel">公司</td>
          <td class="tdContent">{{ replacementBill.factoryNo }}</td>
        </tr>
        <tr>
          <td class="tableLabel">生产地</td>
          <td class="tdContent">{{ replacementBill.problemAddress }}</td>
          <td class="tableLabel">制单人</td>
          <td class="tdContent">{{ replacementBill.creatorName }}</td>
          <td class="tableLabel">制单时间</td>
          <td class="tdContent">{{ replacementBill.createTime }}</td>
        </tr>
        <tr>
          <td class="tableLabel">销售订单号</td>
          <td class="tdContent" colspan="5">{{ replacementBill.salesOrderNo }}</td>
        </tr>
        <tr>
          <td class="tableLabel">责任部门</td>
          <td class="tdContent" colspan="5" v-if="!disableDepartment">
            <el-checkbox-group v-model="approveDepartment" :disabled="disableDepartment" @change="departmentChange()">
              <el-checkbox label="技术"/>
              <el-checkbox label="上海生产"/>
              <el-checkbox label="江苏电阻生产"/>
              <el-checkbox label="江苏电抗生产"/>
              <el-checkbox label="上海物流"/>
              <el-checkbox label="江苏物流"/>
              <el-checkbox label="业务南方区"/>
              <el-checkbox label="业务北方区"/>
              <el-checkbox label="上海品质"/>
              <el-checkbox label="江苏品质"/>
              <el-checkbox label="上海采购"/>
              <el-checkbox label="江苏采购"/>
              <el-checkbox label="江苏钣金生产"/>
              <el-checkbox label="上海工艺"/>
              <el-checkbox label="江苏工艺"/>
            </el-checkbox-group>
          </td>
          <td v-else colspan="5">
            {{ replacementBill.improvementDepartment }}
          </td>
        </tr>
        <tr>
          <td class="tableLabel">临时解决方案</td>
          <td class="tdContent" colspan="5" v-if="!disableProblemSolution">
            <el-input v-model="replacementBill.problemSolution" type="textarea"/>
          </td>
          <td v-else colspan="5">
            {{ replacementBill.problemSolution }}
          </td>
        </tr>
        <tr>
          <td class="tableLabel">库存盘查</td>
          <td class="tdContent" colspan="5" v-if="!disableProblemSolution">
            <el-input v-model="replacementBill.productInformation" type="textarea"/>
          </td>
          <td v-else colspan="5">
            {{ replacementBill.productInformation }}
          </td>
        </tr>
        <tr>
          <td class="tableLabel">最终责任判断</td>
          <td class="tdContent" colspan="5" v-if="!disableFinalConclusion">
            <el-input v-model="replacementBill.finalConclusion" type="textarea"/>
          </td>
          <td v-else colspan="5">
            {{ replacementBill.finalConclusion }}
          </td>
        </tr>
        <tr>
          <td class="tableLabel">填写损失</td>
          <td class="tdContent" colspan="5" v-if="!disableFinalConclusion">
            <el-input v-model="replacementBill.comment" type="textarea"/>
          </td>
          <td v-else colspan="5">
            {{ replacementBill.comment }}
          </td>
        </tr>
        <tr>
          <td class="tableLabel">备注</td>
          <td class="tdContent" colspan="5">{{ replacementBill.note }}</td>
        </tr>
        <tr v-if="!disableTask">
          <td class="tableLabel">任务</td>
          <td class="tdContent" colspan="5">
            <div style="display: flex;">
              <div>{{ replacementBill.serviceType }}</div>
              <el-button style="margin-left: 20px;" type="primary"
                         @click="$refs.task.open(replacementBill.serviceType)">派发任务</el-button>
            </div>

          </td>
        </tr>
        </tbody>
      </table>
      <el-table id="details" style="margin-top: 5px;" :data="replacementBill.details" border stripe height="20vh">
        <el-table-column prop="materialNo" align="left" label="物料编号" width="130"/>
        <el-table-column prop="materialName" align="left" label="物料名称" width="120"/>
        <el-table-column prop="specification" align="center" label="规格型号"/>
        <el-table-column prop="quantity" align="center" label="数量" width="90"/>
        <el-table-column prop="deliveryDate" label="出货日期" align="center" width="120"/>
        <el-table-column prop="badQuantity" align="center" label="异常数量" width="100"/>
        <el-table-column prop="materialType" align="center" label="产品类型" width="90"/>
        <el-table-column prop="returnProd" align="center" label="是否退货" width="90"/>
        <el-table-column prop="returnDate" label="预计退回时间" align="center" width="120"/>
        <el-table-column prop="ProblemDesc" align="center" label="备注" width="240"/>
      </el-table>
      <div>
        <div
            style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
          附件
        </div>
        <upload-file
            ref="upload"
            :show-file-list="false"
            :auth-index="authIndex"
            style="text-align: right;margin-top: 2px;"
            @upload-success="uploadSuccess"/>
        <el-table border :data="replacementBill.attachments">
          <el-table-column type="index" align="center" label="#" width="55"/>
          <el-table-column prop="fileName" align="left" label="名称">
            <template slot-scope="scope">
              <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="creatorName" align="left" label="创建人" width="100"/>
          <el-table-column prop="createTime" align="left" label="创建时间" width="140"/>
          <el-table-column label="操作" align="center" width="120" class-name="vm-table_operate">
            <template slot-scope="scope">
              <el-button type="danger" :disabled="scope.row.createTime"
                         @click="replacementBill.attachments.splice(scope.$index, 1)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--      :disabled="disableSolution"-->
      <div v-if="showSolution&&disableSolution" style="margin-top: 20px;">
        <el-form
            ref="form"
            :model="replacementBill"
            class="form">
          <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">
            解决方案
          </div>
          <el-table :disabled="disableSolution" :data="listSolution1_0" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" width="160" label="产品状态分布(围堵措施)"/>
            <el-table-column prop="quantity" align="center" label="数量" width="100"/>
            <el-table-column prop="solution" align="center" label="处理方案"/>
            <el-table-column prop="feedBack" align="center" label="处理结果" width="100"/>
            <el-table-column prop="solutionHandler" align="center" label="责任人" width="100"/>
            <el-table-column prop="fileName" align="center" label="附件" width="250">
              <template slot-scope="scope">
                <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="completionTimePlan" label="出货日期" align="center" width="160"/>
            <el-table-column prop="note" align="center" label="说明文字" width="200"/>
          </el-table>
          <el-table :disabled="disableSolution" :data="listSolution1_1" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" width="160" label="产品状态分布(围堵措施)"/>
            <el-table-column prop="quantity" align="center" label="数量" width="100"/>
            <el-table-column prop="solution" align="center" label="处理方案"/>
            <el-table-column prop="feedBack" align="center" label="处理结果" width="100"/>
            <el-table-column prop="solutionHandler" align="center" label="责任人" width="100"/>
            <el-table-column prop="fileName" align="center" label="附件" width="250">
              <template slot-scope="scope">
                <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="completionTimePlan" label="出货日期" align="center" width="160"/>
            <el-table-column prop="note" align="center" label="说明文字" width="200"/>
          </el-table>
          <el-table :disabled="disableSolution" :data="listSolution1_2" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" width="160" label="产品状态分布(围堵措施)"/>
            <el-table-column prop="quantity" align="center" label="数量" width="100"/>
            <el-table-column prop="solution" align="center" label="处理方案"/>
            <el-table-column prop="feedBack" align="center" label="处理结果" width="100"/>
            <el-table-column prop="solutionHandler" align="center" label="责任人" width="100"/>
            <el-table-column prop="fileName" align="center" label="附件" width="250">
              <template slot-scope="scope">
                <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="completionTimePlan" label="出货日期" align="center" width="160"/>
            <el-table-column prop="note" align="center" label="说明文字" width="200"/>
          </el-table>
          <el-table :disabled="disableSolution" :data="listSolution1_3" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" width="160" label="产品状态分布(围堵措施)"/>
            <el-table-column prop="quantity" align="center" label="数量" width="100"/>
            <el-table-column prop="solution" align="center" label="处理方案"/>
            <el-table-column prop="feedBack" align="center" label="处理结果" width="100"/>
            <el-table-column prop="solutionHandler" align="center" label="责任人" width="100"/>
            <el-table-column prop="fileName" align="center" label="附件" width="250">
              <template slot-scope="scope">
                <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="completionTimePlan" label="出货日期" align="center" width="160"/>
            <el-table-column prop="note" align="center" label="说明文字" width="200"/>
          </el-table>
          <el-table :disabled="disableSolution" :data="listSolution1_4" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" width="160" label="产品状态分布(围堵措施)"/>
            <el-table-column prop="quantity" align="center" label="数量" width="100"/>
            <el-table-column prop="solution" align="center" label="处理方案"/>
            <el-table-column prop="feedBack" align="center" label="处理结果" width="100"/>
            <el-table-column prop="solutionHandler" align="center" label="责任人" width="100"/>
            <el-table-column prop="fileName" align="center" label="附件" width="250">
              <template slot-scope="scope">
                <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="completionTimePlan" label="出货日期" align="center" width="160"/>
            <el-table-column prop="note" align="center" label="说明文字" width="200"/>
          </el-table>
          <el-table :data="listSolution2" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" width="160"/>
            <el-table-column prop="solution" align="center" label="根本原因分析"/>
            <el-table-column prop="fileName" align="center" label="附件" width="300">
              <template slot-scope="scope">
                <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="note" align="center" label="说明文字" width="200"/>
          </el-table>

          <el-table :data="listSolution3" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" width="160"/>
            <el-table-column prop="solution" align="center"/>
          </el-table>
          <el-table :data="listSolution4" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" width="160"/>
            <el-table-column prop="solution" align="center" label="永久纠正错误及执行"/>
            <el-table-column prop="fileName" align="center" label="附件" width="300">
              <template slot-scope="scope">
                <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="note" align="center" label="说明文字" width="200"/>
          </el-table>
          <el-table :data="listSolution5" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" width="160"/>
            <el-table-column prop="solution" align="center" label="预防再发生"/>
            <el-table-column prop="note" align="center" label="说明文字" width="200"/>
          </el-table>
          <el-table :data="listSolution6" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" width="160"/>
            <el-table-column prop="solution" align="center" label="文件"/>
            <el-table-column prop="solutionHandler" align="center" label="负责人" width="100"/>
            <el-table-column prop="completionTimePlan" align="center" label="完成日期" width="150"/>
            <el-table-column prop="fileNo" align="center" label="文件编号" width="100"/>
            <el-table-column prop="qmConfirm" align="center" label="说明文字" width="200"/>
          </el-table>

        </el-form>
      </div>
      <div v-if="showSolution&&!disableSolution">
        <el-form
            ref="form"
            :model="replacementBill"
            class="form">
          <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">
            解决方案
          </div>
          <upload-file
              ref="upload" :disabled="disableSolution"
              :show-file-list="false"
              :auth-index="192"
              style="text-align: right;margin-top: 2px;"
              @upload-success="uploadSuccess1_0"/>
          <el-table :disabled="disableSolution" :data="listSolution1_0" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" label="产品状态分布(围堵措施)" width="160"/>
            <el-table-column prop="quantity" align="center" label="数量" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.quantity"/>
              </template>
            </el-table-column>
            <el-table-column prop="solution" align="center" label="处理方案">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solution" type="textarea" autosize placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column prop="feedBack" align="center" label="处理结果" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.feedBack"/>
              </template>
            </el-table-column>
            <el-table-column prop="solutionHandler" align="center" label="责任人" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solutionHandler"/>
              </template>
            </el-table-column>
            <el-table-column prop="fileName" align="center" label="附件" width="250">
              <template slot-scope="scope">
                <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
                <el-Button type="danger" style="margin-left: 2px;" @click="deleteFile1_0()" v-if="scope.row.fileName">
                  删除
                </el-Button>
              </template>
            </el-table-column>
            <el-table-column prop="completionTimePlan" label="出货日期" align="center" width="160">
              <template slot-scope="scope">
                <el-date-picker
                    v-model="scope.row.completionTimePlan"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                    placeholder="请选择日期"/>
              </template>
            </el-table-column>
            <el-table-column prop="note" align="center" label="说明文字" width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.note" type="textarea" autosize placeholder="请输入"/>
              </template>
            </el-table-column>
          </el-table>
          <upload-file
              ref="upload" :disabled="disableSolution"
              :show-file-list="false"
              :auth-index="192"
              style="text-align: right;margin-top: 2px;"
              @upload-success="uploadSuccess1_1"/>
          <el-table :disabled="disableSolution" :data="listSolution1_1" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" label="产品状态分布(围堵措施)" width="160"/>
            <el-table-column prop="quantity" align="center" label="数量" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.quantity"/>
              </template>
            </el-table-column>
            <el-table-column prop="solution" align="center" label="处理方案">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solution" type="textarea" autosize placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column prop="feedBack" align="center" label="处理结果" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.feedBack"/>
              </template>
            </el-table-column>
            <el-table-column prop="solutionHandler" align="center" label="责任人" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solutionHandler"/>
              </template>
            </el-table-column>
            <el-table-column prop="fileName" align="center" label="附件" width="250">
              <template slot-scope="scope">
                <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
                <el-Button type="danger" style="margin-left: 2px;" @click="deleteFile1_1()" v-if="scope.row.fileName">
                  删除
                </el-Button>
              </template>
            </el-table-column>
            <el-table-column prop="completionTimePlan" label="出货日期" align="center" width="160">
              <template slot-scope="scope">
                <el-date-picker
                    v-model="scope.row.completionTimePlan"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                    placeholder="请选择日期"/>
              </template>
            </el-table-column>
            <el-table-column prop="note" align="center" label="说明文字" width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.note" type="textarea" autosize placeholder="请输入"/>
              </template>
            </el-table-column>
          </el-table>
          <upload-file
              ref="upload" :disabled="disableSolution"
              :show-file-list="false"
              :auth-index="192"
              style="text-align: right;margin-top: 2px;"
              @upload-success="uploadSuccess1_2"/>
          <el-table :disabled="disableSolution" :data="listSolution1_2" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" label="产品状态分布(围堵措施)" width="160"/>
            <el-table-column prop="quantity" align="center" label="数量" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.quantity"/>
              </template>
            </el-table-column>
            <el-table-column prop="solution" align="center" label="处理方案">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solution" type="textarea" autosize placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column prop="feedBack" align="center" label="处理结果" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.feedBack"/>
              </template>
            </el-table-column>
            <el-table-column prop="solutionHandler" align="center" label="责任人" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solutionHandler"/>
              </template>
            </el-table-column>
            <el-table-column prop="fileName" align="center" label="附件" width="250">
              <template slot-scope="scope">
                <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
                <el-Button type="danger" style="margin-left: 2px;" @click="deleteFile1_2()" v-if="scope.row.fileName">
                  删除
                </el-Button>
              </template>
            </el-table-column>
            <el-table-column prop="completionTimePlan" label="出货日期" align="center" width="160">
              <template slot-scope="scope">
                <el-date-picker
                    v-model="scope.row.completionTimePlan"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                    placeholder="请选择日期"/>
              </template>
            </el-table-column>
            <el-table-column prop="note" align="center" label="说明文字" width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.note" type="textarea" autosize placeholder="请输入"/>
              </template>
            </el-table-column>
          </el-table>
          <upload-file
              ref="upload" :disabled="disableSolution"
              :show-file-list="false"
              :auth-index="192"
              style="text-align: right;margin-top: 2px;"
              @upload-success="uploadSuccess1_3"/>
          <el-table :disabled="disableSolution" :data="listSolution1_3" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" label="产品状态分布(围堵措施)" width="160"/>
            <el-table-column prop="quantity" align="center" label="数量" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.quantity"/>
              </template>
            </el-table-column>
            <el-table-column prop="solution" align="center" label="处理方案">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solution" type="textarea" autosize placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column prop="feedBack" align="center" label="处理结果" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.feedBack"/>
              </template>
            </el-table-column>
            <el-table-column prop="solutionHandler" align="center" label="责任人" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solutionHandler"/>
              </template>
            </el-table-column>
            <el-table-column prop="fileName" align="center" label="附件" width="250">
              <template slot-scope="scope">
                <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
                <el-Button type="danger" style="margin-left: 2px;" @click="deleteFile1_3()" v-if="scope.row.fileName">
                  删除
                </el-Button>
              </template>
            </el-table-column>
            <el-table-column prop="completionTimePlan" label="出货日期" align="center" width="160">
              <template slot-scope="scope">
                <el-date-picker
                    v-model="scope.row.completionTimePlan"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                    placeholder="请选择日期"/>
              </template>
            </el-table-column>
            <el-table-column prop="note" align="center" label="说明文字" width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.note" type="textarea" autosize placeholder="请输入"/>
              </template>
            </el-table-column>
          </el-table>
          <upload-file
              ref="upload" :disabled="disableSolution"
              :show-file-list="false"
              :auth-index="192"
              style="text-align: right;margin-top: 2px;"
              @upload-success="uploadSuccess1_4"/>
          <el-table :disabled="disableSolution" :data="listSolution1_4" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" label="产品状态分布(围堵措施)" width="160"/>
            <el-table-column prop="quantity" align="center" label="数量" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.quantity"/>
              </template>
            </el-table-column>
            <el-table-column prop="solution" align="center" label="处理方案">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solution" type="textarea" autosize placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column prop="feedBack" align="center" label="处理结果" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.feedBack"/>
              </template>
            </el-table-column>
            <el-table-column prop="solutionHandler" align="center" label="责任人" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solutionHandler"/>
              </template>
            </el-table-column>
            <el-table-column prop="fileName" align="center" label="附件" width="250">
              <template slot-scope="scope">
                <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
                <el-Button type="danger" style="margin-left: 2px;" @click="deleteFile1_4()" v-if="scope.row.fileName">
                  删除
                </el-Button>
              </template>
            </el-table-column>
            <el-table-column prop="completionTimePlan" label="出货日期" align="center" width="160">
              <template slot-scope="scope">
                <el-date-picker
                    v-model="scope.row.completionTimePlan"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                    placeholder="请选择日期"/>
              </template>
            </el-table-column>
            <el-table-column prop="note" align="center" label="说明文字" width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.note" type="textarea" autosize placeholder="请输入"/>
              </template>
            </el-table-column>
          </el-table>
          <div>
            <upload-file
                ref="upload" :disabled="disableSolution"
                :show-file-list="false"
                :auth-index="192"
                style="text-align: right;margin-top: 2px;"
                @upload-success="uploadSuccess2"/>
            <el-table :data="listSolution2" style="margin-top: 5px;">
              <el-table-column prop="solutionType" align="center" width="160"/>
              <el-table-column prop="solution" align="center" label="根本原因分析">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.solution" type="textarea" autosize placeholder="请输入"/>
                </template>
              </el-table-column>
              <el-table-column prop="fileName" align="center" label="附件" width="300">
                <template slot-scope="scope">
                  <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
                  <el-Button type="danger" style="margin-left: 2px;" @click="deleteFile2()" v-if="scope.row.fileName">
                    删除
                  </el-Button>
                </template>
              </el-table-column>
              <el-table-column prop="note" align="center" label="说明文字" width="200">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.note" type="textarea" autosize placeholder="请输入"/>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-table :data="listSolution3" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" width="160"/>
            <el-table-column prop="solution" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solution" type="textarea" autosize placeholder="请输入"/>
              </template>
            </el-table-column>
          </el-table>
          <upload-file
              ref="upload" :disabled="disableSolution"
              :show-file-list="false"
              :auth-index="192"
              style="text-align: right;margin-top: 2px;"
              @upload-success="uploadSuccess4"/>
          <el-table :data="listSolution4" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" width="160"/>
            <el-table-column prop="solution" align="center" label="永久纠正错误及执行">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solution" type="textarea" autosize placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column prop="fileName" align="center" label="附件" width="300">
              <template slot-scope="scope">
                <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
                <el-Button type="danger" style="margin-left: 2px;" @click="deleteFile4()" v-if="scope.row.fileName">删除
                </el-Button>
              </template>
            </el-table-column>
            <el-table-column prop="note" align="center" label="说明文字" width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.note" type="textarea" autosize placeholder="请输入"/>
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="listSolution5" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" width="160"/>
            <el-table-column prop="solution" align="center" label="预防再发生">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solution" type="textarea" autosize placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column prop="note" align="center" label="说明文字" width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.note" type="textarea" autosize placeholder="请输入"/>
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="listSolution6" style="margin-top: 5px;">
            <el-table-column prop="solutionType" align="center" width="160"/>
            <el-table-column prop="solution" align="center" label="文件">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solution" type="textarea" autosize placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column prop="solutionHandler" align="center" label="负责人" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.solutionHandler"/>
              </template>
            </el-table-column>
            <el-table-column prop="completionTimePlan" align="center" label="完成日期" width="150">
              <template slot-scope="scope">
                <el-date-picker
                    v-model="scope.row.completionTimePlan"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                    placeholder="请选择日期"/>
              </template>
            </el-table-column>
            <el-table-column prop="fileNo" align="center" label="文件编号" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.fileNo"/>
              </template>
            </el-table-column>
            <el-table-column prop="qmConfirm" align="center" label="说明文字" width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.qmConfirm" type="textarea" autosize placeholder="请输入"/>
              </template>
            </el-table-column>
          </el-table>

        </el-form>
      </div>

    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
    <task-edit1 ref="task" @returnData="returnTask"/>
  </div>
</template>
<script>
import HandleDetail from "@/views/workFlow/HandleDetail";
import constant from "@/util/constant";
import UploadFile from "@/components/UploadFile";
import loginUtil from "@/util/loginUtil";
import TaskEdit1 from "../information/TaskManagement/TaskEdit1";

export default {
  // name: "ReplacementBillApplicationPreview",
  components: {HandleDetail, UploadFile,TaskEdit1},
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      billId: "",
      billType: "",
      sequId: "",
      authIndex: 625,
      constant,
      approveDepartment: [],
      nodeId: "",
      disableDepartment: false,
      disableProblemSolution: false,
      disableFinalConclusion: false,
      disableTask:false,
      isHidden: false,
      disableSolution: false,
      showSolution: true,
      // needTech: false,
      // needProd: false,
      // needTrans: false,
      // needSell: false,
      // needQue: false,
      // needPurc: false,
      replacementBill: {
        problemSolution: "",
        productInformation: "",
        finalConclusion: "",
        comment: "",
        improvementDepartment: "",
        serviceType:"",
        details: [],
        solutions: [],
      },
      listSolution1_0: [],
      listSolution1_1: [],
      listSolution1_2: [],
      listSolution1_3: [],
      listSolution1_4: [],
      listSolution2: [],
      listSolution3: [],
      listSolution4: [],
      listSolution5: [],
      listSolution6: [],
      solution1_0: {
        rowIndex: 1,
        solutionType: "在生产",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution1_1: {
        rowIndex: 2,
        solutionType: "库存",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution1_2: {
        rowIndex: 3,
        solutionType: "运输途中",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution1_3: {
        rowIndex: 4,
        solutionType: "已出货",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution1_4: {
        rowIndex: 5,
        solutionType: "受影响的其它材料",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution2: {
        rowIndex: 6,
        solutionType: "根本原因分析",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution3: {
        rowIndex: 7,
        solutionType: "指定临时对策",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution4: {
        rowIndex: 8,
        solutionType: "永久纠正错误及执行",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution5: {
        rowIndex: 9,
        solutionType: "预防再发生",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
      solution6: {
        rowIndex: 10,
        solutionType: "涉及时，更新这些项目反映更改内容",
        productStatus: "",
        quantity: "",
        solution: "",
        feedBack: "",
        solutionHandler: "",
        completionTimePlan: "",
        filePath: "",
        fileName: "",
        fileNo: "",
        qmConfirm: "",
        note: "",
      },
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        if (val.query.billId) {
          this.billId = val.query.billId;
          this.billType = val.query.billType;
          this.sequId = val.query.sequId;
          this.getData(val.query.billId);
          this.getNodeValue();
        }
      },
    },
    params: {
      handler() {
        this.doApprove();
      },
    },
  },
  methods: {
    getData() {
      this.listSolution1_0 = [];
      this.listSolution1_1 = [];
      this.listSolution1_2 = [];
      this.listSolution1_3 = [];
      this.listSolution1_4 = [];
      this.listSolution2 = [];
      this.listSolution3 = [];
      this.listSolution4 = [];
      this.listSolution5 = [];
      this.listSolution6 = [];
      this.listSolution1_0.push(this.solution1_0);
      this.listSolution1_1.push(this.solution1_1);
      this.listSolution1_2.push(this.solution1_2);
      this.listSolution1_3.push(this.solution1_3);
      this.listSolution1_4.push(this.solution1_4);
      this.listSolution2.push(this.solution2);
      this.listSolution3.push(this.solution3);
      this.listSolution4.push(this.solution4);
      this.listSolution5.push(this.solution5);
      this.listSolution6.push(this.solution6);

      this.$emit("loading-status", {"loading": true});
      this.$http
          .get("basic", `replacementBills/${this.billId}`)
          .then(resp => {
            this.$emit("loading-status", {"loading": false});
            this.replacementBill = resp.data;
            if (this.replacementBill.solutions.length > 0) {
              this.updateSolution(this.listSolution1_0, this.replacementBill.solutions[0]);
              this.updateSolution(this.listSolution1_1, this.replacementBill.solutions[1]);
              this.updateSolution(this.listSolution1_2, this.replacementBill.solutions[2]);
              this.updateSolution(this.listSolution1_3, this.replacementBill.solutions[3]);
              this.updateSolution(this.listSolution1_4, this.replacementBill.solutions[4]);
              this.updateSolution(this.listSolution2, this.replacementBill.solutions[5]);
              this.updateSolution(this.listSolution3, this.replacementBill.solutions[6]);
              this.updateSolution(this.listSolution4, this.replacementBill.solutions[7]);
              this.updateSolution(this.listSolution5, this.replacementBill.solutions[8]);
              this.updateSolution(this.listSolution6, this.replacementBill.solutions[9]);
            }
            //审批部门
            if (this.replacementBill.improvementDepartment) {
              this.approveDepartment = this.replacementBill.improvementDepartment.split(",");
            }
          });
    },

    updateSolution(listSolution, solution) {
      listSolution.forEach((item) => {
        item.productStatus = solution.productStatus;
        item.quantity = solution.quantity;
        item.solution = solution.solution;
        item.feedBack = solution.feedBack;
        item.solutionHandler = solution.solutionHandler;
        item.completionTimePlan = solution.completionTimePlan;
        item.filePath = solution.filePath;
        item.fileName = solution.fileName;
        item.fileNo = solution.fileNo;
        item.qmConfirm = solution.qmConfirm;
        item.note = solution.note;
      });
    },
    //选择部门
    departmentChange() {
      if (this.approveDepartment) {
        this.replacementBill.improvementDepartment = this.approveDepartment.join(",");
      } else {
        this.replacementBill.improvementDepartment = "";
      }
    },
    returnTask(task){
      this.replacementBill.serviceType=task.taskNo;
    },
    uploadSuccess(fileList) {
      if (fileList.length) {
        const params = {
          fileName: fileList[0].name,
          filePath: fileList[0].key,
          creatorId: loginUtil.getUserId(),
          creatorName: loginUtil.getName(),
        };
        this.replacementBill.attachments.push(params);
      }
    },

    // 下载
    downLoad(row) {
      this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(row.filePath)}`).then((res) => {
        if (res.success) {
          window.open(res.data);
        }
      });
    },
    uploadSuccess1_0(fileList) {
      if (fileList.length) {
        this.listSolution1_0.forEach((item) => {
          item.fileName = fileList[0].name;
          item.filePath = fileList[0].key;
        });
      }
    },
    deleteFile1_0() {
      this.listSolution1_0.forEach((item) => {
        item.fileName = "";
        item.filePath = "";
      });
    },

    uploadSuccess1_1(fileList) {
      if (fileList.length) {
        this.listSolution1_1.forEach((item) => {
          item.fileName = fileList[0].name;
          item.filePath = fileList[0].key;
        });
      }
    },
    deleteFile1_1() {
      this.listSolution1_1.forEach((item) => {
        item.fileName = "";
        item.filePath = "";
      });
    },
    uploadSuccess1_2(fileList) {
      if (fileList.length) {
        this.listSolution1_2.forEach((item) => {
          item.fileName = fileList[0].name;
          item.filePath = fileList[0].key;
        });
      }
    },
    deleteFile1_2() {
      this.listSolution1_2.forEach((item) => {
        item.fileName = "";
        item.filePath = "";
      });
    },
    uploadSuccess1_3(fileList) {
      if (fileList.length) {
        this.listSolution1_3.forEach((item) => {
          item.fileName = fileList[0].name;
          item.filePath = fileList[0].key;
        });
      }
    },
    deleteFile1_3() {
      this.listSolution1_3.forEach((item) => {
        item.fileName = "";
        item.filePath = "";
      });
    },
    uploadSuccess1_4(fileList) {
      if (fileList.length) {
        this.listSolution1_4.forEach((item) => {
          item.fileName = fileList[0].name;
          item.filePath = fileList[0].key;
        });
      }
    },
    deleteFile1_4() {
      this.listSolution1_4.forEach((item) => {
        item.fileName = "";
        item.filePath = "";
      });
    },
    uploadSuccess2(fileList) {
      if (fileList.length) {
        this.listSolution2.forEach((item) => {
          item.fileName = fileList[0].name;
          item.filePath = fileList[0].key;
        });
      }
    },
    deleteFile2() {
      this.listSolution2.forEach((item) => {
        item.fileName = "";
        item.filePath = "";
      });
    },
    uploadSuccess4(fileList) {
      if (fileList.length) {
        this.listSolution4.forEach((item) => {
          item.fileName = fileList[0].name;
          item.filePath = fileList[0].key;
        });
      }
    },
    deleteFile4() {
      this.listSolution4.forEach((item) => {
        item.fileName = "";
        item.filePath = "";
      });
    },
    getNodeValue() {
      let params = {
        billType: this.billType,
        billId: this.billId,
        sequId: this.sequId,
        approveVar: this.approveVar,
      };
      this.$http.get("basic", "applications/approve", params).then((resp) => {
        this.nodeId = resp.data.nodeId;
        this.checkNode();
      });
    },

    //校验节点
    checkNode() {
      if (this.nodeId == "QMApprove") {
        this.disableDepartment = false;
        this.disableProblemSolution = false;
      } else {
        this.disableDepartment = true;
        this.disableProblemSolution = true;
      }

      if (this.nodeId != "QMApprove" && this.nodeId != "ManagerApprove" && this.nodeId != "GeneralApprove") {
        this.showSolution = true;
      } else {
        this.showSolution = false;
      }

      if (this.nodeId == "QMApprove"
          || this.nodeId == "ManagerApprove"
          || this.nodeId == "GeneralApprove"
          || this.nodeId == "QMApprove2"
          || this.nodeId == "GeneralApprove2"
          || this.nodeId == "QMFileApprove") {
        this.disableSolution = true;
      } else {
        this.disableSolution = false;
      }

      if (this.nodeId == "QMApprove2") {
        this.disableFinalConclusion = false;
      } else {
        this.disableFinalConclusion = true;
      }
      if (this.nodeId == "GeneralApprove2") {
        this.disableTask=false;
      } else {
        this.disableTask=true;
      }
    },

    doApprove() {
      let billParam = [];
      let approveVar = "";
      //质量审核
      if (this.nodeId == "QMApprove") {
        if (this.approveDepartment == null || this.approveDepartment == "") {
          return this.$message.error("责任部门不可为空！！！");
        }

        // approveVar = "DepartmentNo#" + this.departmentNo;
        let varList = [];
        varList.push("NeedTech#" + (this.approveDepartment.includes("技术") ? "true" : "false"));
        varList.push("NeedProd#" + (this.approveDepartment.includes("上海生产") ? "true" : "false"));
        varList.push("NeedProdDzJs#" + (this.approveDepartment.includes("江苏电阻生产") ? "true" : "false"));
        varList.push("NeedProdDkJs#" + (this.approveDepartment.includes("江苏电抗生产") ? "true" : "false"));
        varList.push("NeedTrans#" + (this.approveDepartment.includes("上海物流") ? "true" : "false"));
        varList.push("NeedTrans1#" + (this.approveDepartment.includes("江苏物流") ? "true" : "false"));
        varList.push("NeedSell#" + (this.approveDepartment.includes("业务南方区") ? "true" : "false"));
        varList.push("NeedSellNorth#" + (this.approveDepartment.includes("业务北方区") ? "true" : "false"));
        varList.push("NeedQue#" + (this.approveDepartment.includes("上海品质") ? "true" : "false"));
        varList.push("NeedQue1#" + (this.approveDepartment.includes("江苏品质") ? "true" : "false"));
        varList.push("NeedPurc#" + (this.approveDepartment.includes("上海采购") ? "true" : "false"));
        varList.push("NeedPurc1#" + (this.approveDepartment.includes("江苏采购") ? "true" : "false"));
        varList.push("NeedBjJs#" + (this.approveDepartment.includes("江苏钣金生产") ? "true" : "false"));
        varList.push("NeedGongyi#" + (this.approveDepartment.includes("上海工艺") ? "true" : "false"));
        varList.push("NeedGongyi1#" + (this.approveDepartment.includes("江苏工艺") ? "true" : "false"));

        if (varList.length > 0) {
          approveVar = varList.join("|");
        }

        // this.updateBill();
      }
      //部门审批保存
      if (this.nodeId != "QMApprove"
          && this.nodeId != "ManagerApprove"
          && this.nodeId != "GeneralApprove"
          && this.nodeId != "QMApprove2"
          && this.nodeId != "GeneralApprove2") {
        let solutions = [];
        solutions.push(this.listSolution1_0[0]);
        solutions.push(this.listSolution1_1[0]);
        solutions.push(this.listSolution1_2[0]);
        solutions.push(this.listSolution1_3[0]);
        solutions.push(this.listSolution1_4[0]);
        solutions.push(this.listSolution2[0]);
        solutions.push(this.listSolution3[0]);
        solutions.push(this.listSolution4[0]);
        solutions.push(this.listSolution5[0]);
        solutions.push(this.listSolution6[0]);
        this.replacementBill.solutions = solutions;

        // this.updateBill();
      }

      // //质量复审
      // if (this.nodeId == "QMApprove2") {
      //
      // }

      this.updateBill();

      let params = {
        billId: parseInt(this.billId),
        billType: parseInt(this.billType),
        sequId: parseInt(this.sequId),
        actionType: this.params.actionType,
        approveNote: this.params.approveNote,
        untreadedFlowId: this.params.untreadedFlowId,
        transferTo: this.params.transferTo,
        approveVar: approveVar,
        billParam: JSON.stringify(billParam),
      };
      this.$emit("loading-status", {loading: true});
      this.$http
          .post("basic", "applications/doApprove", params)
          .then((resp) => {
            this.$emit("loading-status", {loading: false});
            if (resp.success) {
              this.$message.success("保存成功");
              // if (["regionManager", "fiApprove", "GeneralManager"].includes(this.nodeId)) {
              //   this.updateHandle();
              // }

              //发送通知
              this.$http.post("basic", "replacementBills/updateNotify/" + this.billId).catch(() => {
              });

              // 关闭标签
              this.$bus.$emit("closeTag", this.$route);
              this.$router.push({
                path: "/workFlow/ReplacementBillApplication",
              });
            }
          })
          .catch(() => {
            this.$emit("loading-status", {loading: false});
          });
    },

    updateBill() {
      this.$http.post("basic", "replacementBills/save/0", this.replacementBill)
          .then(() => {
          })
          .catch(() => {
          });
    },

  },
};

</script>
<style lang="scss">
.body {
  .el-button + .el-button {
    margin-left: 0;
  }

  .el-tabs--border-card > .el-tabs__content {
    padding: 10px;
  }

  .body-btn {
    margin-bottom: 2px;
    margin-right: 2px;
  }

  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border-width: 1px;
    border-color: #dddddd;
    border-collapse: collapse;
    width: 100%;
  }

  table.gridtable th {
    text-align: left;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #dddddd;
    background-color: #D1E6F5;
  }

  table.gridtable td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #dddddd;
  }

  .tableLabel {
    width: 10%;
    text-align: right;
    background-color: #D1E6F5;
  }
}
</style>
